export default __webpack_public_path__ + "static/media/sellingPointOne.0a402bdb.jpg";